export default "__VITE_ASSET__BZX$YU2L__"